import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';

import { InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import { List } from 'APP/components/List/List';

import { IForwardTargetData, ISharedDataViewItemData } from '../../ShareDataView.types';
import { ShareDataViewListContainer } from '../../ShareDataViewListContainer/ShareDataViewListContainer';
import { ITEM_COMPONENT } from '../SharedDataViewTabs';
import { useSharedDataViewTabAllPresenter } from './SharedDataViewTabAll.presenter';

interface ISharedDataViewTabAllProps {
  multiselect: boolean;
  onClickItem(item: ISharedDataViewItemData): void;
  searchValue: string;
  selection: ISharedDataViewItemData[];
}

export const SharedDataViewTabAll: FC<ISharedDataViewTabAllProps> = observer((props) => {
  const { searchValue, selection, multiselect, onClickItem } = props;

  const presenter = useSharedDataViewTabAllPresenter({
    selection,
    searchValue,
    onClickItem,
  });

  const renderItem = (item: IForwardTargetData): ReactElement => {
    const Component = ITEM_COMPONENT[item.data.itemType];

    return (
      <Component
        data={item.data}
        isSelected={item.isSelected}
        withCheckbox={multiselect}
        onClick={item.onClick}
      />
    );
  };

  return (
    <ShareDataViewListContainer>
      <List
        data={presenter.content}
        keyExtractor={presenter.keyExtractor}
        renderItem={renderItem}
        ListEmptyComponent={
          <InfoBlock
            title={presenter.infoBlockTitle}
            descriptions={presenter.infoBlockDescriptions}
            type={InfoBlockTypes.Modal}
            image={
              !searchValue
                ? getMascotImageSrc(PROJECT_CONFIG.imageAssets.contacts)
                : getMascotImageSrc(PROJECT_CONFIG.imageAssets.notFound)
            }
          />
        }
      />
    </ShareDataViewListContainer>
  );
});
